export default {
  lang: 'Idioma',
  currency: 'Moneda',
  validGoodUrlFail: 'esto no es un enlace de producto correcto',
  product: 'productos',
  productHolder: 'Ingrese el nombre del producto o el enlace',
  // productHolder: 'Ingrese el nombre del producto o el enlace/Enlace de la tienda/PI',
  shop: 'Tienda',
  shopHolder: 'Ingrese el nombre de la tienda o el enlace de la tienda',
  purchaseAgent: 'Inicio ',
  transport: 'Envío',
  manualOrdering: 'Pedido personalizado',
  guideBook: 'Guía',
  help: 'Ayuda',
  tools: 'Herramientas',
  customerService: 'Servicio al cliente',
  purchaseGuide: 'Guía de compras',
  payment: 'Pago',
  delivery: 'Entrega',
  afterSaleService: 'Servicio postventa',
  insuranceCompensation: 'Seguro y compensación',
  contactInfo: 'Información de contacto',
  enterEmail: 'Ingrese su correo electrónico',
  copyRight: 'Copyright©acbuy.com Todos los derechos reservados',
  aboutacbuy: 'Acerca de acbuy',
  contctTime: 'Lun-Vie (09:00-18:00, hora de Beijing)',
  contactEmail: "Correo de servicio: Support{'@'}acbuy.com",
  contactMarket: "Cooperación de marketing: Marketing{'@'}acbuy.com",
  contactCooperation: "Cooperación comercial: Business{'@'}acbuy.com",
  tutorial: 'Tutorial',
  serviceFee: 'Tarifa de servicio',
  orderStatus: 'Guía para principiantes',
  returnRefunds: 'Devoluciones y reembolsos',
  topUp: 'Recargar',
  paypal: 'PayPal',
  internationalCreditCard: 'Tarjeta de crédito internacional',
  telegraphicTransfer: 'Transferencia telegrafica',
  charges: 'Cargos',
  mailRestrictions: 'Restricciones de envío',
  customsTaxation: 'Aduana y tributación',
  receiptInformation: 'Información de recibo',
  helpCenter: 'Centro de ayuda',
  contactUs: 'Contáctenos',
  registerSuccess: 'Registro exitoso',
  registerMsg:
    'Hemos enviado un correo electrónico de verificación a su dirección de correo electrónico. Complete la verificación a tiempo, de lo contrario afectará el uso normal de sus puntos.',
  continueShopping: 'Continuar comprando',
  continueLogin: 'Continuar iniciando sesión',
  verifyQuestion: '¿No recibió el correo electrónico de verificación?',
  verifyResopnseOne:
    '· El correo electrónico de verificación de acbuy puede ser confundido con spam, por favor, revise su carpeta de spam para buscar correos electrónicos',
  verifyResopnseTwo:
    '· El envío puede demorarse unos minutos en ocasiones, por favor, sea paciente y espere',
  verifyResopnseThird:
    '· El correo electrónico de verificación puede demorarse unos minutos. Si no ha recibido el correo electrónico durante mucho tiempo, puede verificar si se ha marcado como spam o reenviar el correo electrónico de verificación',
  agentGuide: 'Guía para agentes nuevos',
  guideBookbtn: 'Guía para principiantes',
  everyonePro: '¡Regístrese ahora y reciba un regalo de bienvenida de ¥2,280!',
  joinAffiliate: 'Únete de inmediato',
  joinacbuy: 'Únase a acbuyDiscord para obtener más beneficios',
  joinDiscord: 'Unirse a Discord',
  productPpurchase: 'Compra de productos',
  shippingToWarehouse: 'Envío al almacén',
  qualityAssurance: 'Garantía de calidad',
  moreCostEffective: 'Más rentable',
  productPpurchaseContent:
    'Compra de productos - usted puede comprar cualquier artículo fácilmente de TaoBao. Sólo tiene que pegar los enlaces del producto TaoBao a la página web de acbuy y realizar un pedido. Acbuy comprará para usted.',
  shippingToWarehouseContent:
    'Envío al almacén - Compra en diferentes tiendas con nuestro servicio y consolidaremos sus pedidos de compra de manera eficiente. Todos los artículos se enviarán al Almacén designado por acbuy y simplificaremos el proceso por su comodidad.',
  qualityAssuranceContent:
    'Garantía de calidad - Después de que sus productos lleguen al Almacén designado por acbuy, realizaremos una inspección de calidad integral de sus productos y le enviaremos el feedback de la inspección para brindarle una mejor experiencia de uso.',
  moreCostEffectiveContent:
    'El transporte concentrado ahorra dinero - en su almacén, puede seleccionar libremente los productos y enviarlos en un solo paquete. Con el servicio de envío global de acbuy, puede enviar los productos a cualquier lugar y disfrutar de un transporte global más sencillo y confiable.',
  introduction: 'Tienda en Taobao by acbuy',
  logoIntroduction: 'Compra como un millonario.',
  reviewOn: 'Reseñas',
  productStoragePeriod: 'Período de almacenamiento del producto',
  inspectionRules: 'Reglas de inspección',
  afterSalesPolicy: 'Política de servicio postventa',
  insuranceAndCompensation: 'Seguro y compensación',
  oneStopService: 'servicio integral',
  whatCustomersSay: 'Lo que dicen nuestros clientes',
  customerSay1:
    'acbuy es el mejor agente de compras que he usado - es la primera vez que uso acbuy y sus productos son más baratos que cualquier otro agente de compras, ¡es realmente sorprendente!',
  customerSay2:
    'Después de ser promotor de acbuy, recibí un reembolso en efectivo de 300 yuanes. Después de eso, obtendré un reembolso en efectivo de no menos del 4% en cada pedido',
  customerSay3:
    'Una experiencia de compra muy agradable - he usado acbuy para comprar en China, con productos de buena calidad, un excelente servicio al cliente y un envío rápido.',
  customerSay4:
    'El mejor agente - la compra se completó el mismo día. Solo tardó 7 días en enviar el paquete a mi casa. Este es el mejor agente actualmente',
  customerFirst: 'Cliente primero, servicio premium',
  customerServiceText: 'Servicio al cliente en línea de Lun-Vie (09:00-18:00, hora de Beijing)',
  faqCategory: 'CATEGORÍAS DE PREGUNTAS FRECUENTES',
  inviteNow: 'Invitación inmediata',
  comeHere: '¡Desbloquear la recompensa increíble!',
  viewTutorial: 'Ver tutorial',
  springText1: 'Cómo comprar en Taobao con Acbuy',
  springText2: 'Invita a tus amigos y gana ¥2000 en efectivo.',
  springText3: 'Duración del evento: del 18 de abril al 20 de mayo',
  category: 'Clasificación',
  hotSale: 'Productos en venta',
  motherText1: 'Ahorros Exclusivos por el Día de la Madre',
  motherText2: 'Win Prizes – Enter Now!',
  motherText3: 'Event Time: April 30 – May 13',
  enterNow: 'Participa Ahora!',
  'i18n-000001': 'Realizar un pedido',
  'i18n-000002': 'Pegar el enlace del producto para enviar el pedido',
  'i18n-000003': 'Inspección de calidad y almacenamiento',
  'i18n-000004': '3-5 fotos de control de calidad gratis y 90 días de almacenamiento gratis',
  'i18n-000005': 'Embalaje',
  'i18n-000006': 'Empaque combinado & Revisar el paquete',
  'i18n-000007': 'Logística internacional',
  'i18n-000008': 'Más de 150 rutas más baratas',
  loveText1: 'Únete a la fiebre del 520',
  loveText2: '¡Cuanto mayor sea tu pedido, mayores serán los premios!',
  loveText3: 'Duración del evento: 14 de mayo – 24 de mayo',
  couponResult: 'Se encontraron {num} resultados para "{keyword}"',
  event: 'Eventos',
}
